module.exports = __webpack_public_path__ + "img/icon_zhigou@2x.25972e82.png";